import Swiper from "swiper";

import { Navigation, FreeMode } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".post-slider-block");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");

    if (!slider) return;

    const trail = slider.querySelector(".swiper-wrapper");
    const prev = slider.querySelector(".swiper-button-prev");
    const next = slider.querySelector(".swiper-button-next");

    const hasProp = (prop, obj) =>
      Object.keys(obj).filter((key) => key === prop).length > 0;

    // Create a variable for data-autoplay on .swiper, if it exists true, false otherwise
    const hasAutoplay = hasProp("autoplay", slider.dataset);
    const overflowHidden = slider.classList.contains("hide-trail");

    const slides = trail.querySelectorAll(".swiper-slide");

    if (!trail || !slides.length) {
      console.warn("El contenedor Swiper no se encontró en:", block);
      return;
    }

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 15,
      centeredSlides: true,
      loop: false,
      speed: 800,
      allowTouchMove: true,
      rewind: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          allowTouchMove: true,
          freeMode: {
            enabled: true,
            sticky: true,
            minimumVelocity: 0.1,
            freeModeMomentum: true,
          },
        },
      },
      modules: [Navigation, FreeMode],
    };

    const swiper = new Swiper(slider, swiperConfig);

    // Activa autoplay solo en pantallas mayores a 768px
    if (window.innerWidth >= 768 && hasAutoplay) {
      swiper.params.autoplay = {
        delay: 2000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
      swiper.autoplay.start();
      new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      }).observe(block);
    }
  });
});
